import React from 'react';

import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

interface QpsQuestionBadgeProps {
  current: number;
  total: number;
}

const QpsQuestionBadge: React.FC<QpsQuestionBadgeProps> = ({ current, total }) => {
  const { t } = useTranslation();

  return <p className={styles.badge}>{t('qps.question.badge', { current, total })}</p>;
};

export default QpsQuestionBadge;
